import {useState} from 'react';
import {CSSObjectWithLabel} from 'react-select';
import {useTheme} from 'styled-components';

export const useSelectStyle = () => {
    const theme = useTheme();
    const [error, setError] = useState(false);

    return {
        setError,
        style: {
            control: (baseStyles: CSSObjectWithLabel) => ({
                ...baseStyles,
                backgroundColor: error ? '#f4cfc0' : 'white',
                borderColor: theme.colors.primary?.main,
                borderWidth: '2px',
                borderRadius: '8px',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: theme.colors.primary?.main,
                },
            }),
        },
    };
};
